module.exports = __webpack_public_path__ + "static/media/fishdom.53a21855.png";